// ============================================
// PAGES & SOURCES — Tab component for Day Report
// ============================================
import { fmt } from "./analyticsHelpers";
import styles from "./DayReport.module.css";

export const DayPagesSources = ({ topPages, referrerBreakdown, deviceBreakdown }) => {
    return (
        <div className={styles.tabContent}>
            <div className={styles.dayPagesGrid}>
                {/* TOP PAGES TABLE */}
                <div className={styles.dayPagesSection}>
                    <h3 className={styles.daySectionTitle}>📄 Pages Visited</h3>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Page</th>
                                <th>Views</th>
                                <th>Avg Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {topPages.map((p, i) => (
                                <tr key={i}>
                                    <td>
                                        {p.title}
                                        <span className={styles.pageUrl}>{p.path}</span>
                                    </td>
                                    <td>{fmt(p.views)}</td>
                                    <td>{Math.floor(p.avgTime / 60)}m {(p.avgTime % 60).toString().padStart(2, "0")}s</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* REFERRERS + DEVICES */}
                <div className={styles.dayPagesSection}>
                    <h3 className={styles.daySectionTitle}>🔗 Referral Sources</h3>
                    <div className={styles.referrerList}>
                        {referrerBreakdown.map((r, i) => (
                            <div key={i} className={styles.referrerRow}>
                                <span className={styles.referrerName}>{r.name}</span>
                                <div className={styles.referrerBar}>
                                    <div className={styles.referrerBarFill} style={{ width: `${Math.min(r.percent * 2, 100)}%` }} />
                                </div>
                                <span className={styles.referrerCount}>{r.count}</span>
                                <span className={styles.referrerPct}>{r.percent}%</span>
                            </div>
                        ))}
                    </div>

                    <h3 className={styles.daySectionTitle} style={{ marginTop: 28 }}>📱 Devices</h3>
                    <div className={styles.dayDeviceRow}>
                        {deviceBreakdown.map((d, i) => (
                            <div key={i} className={styles.dayDeviceCard}>
                                <span className={styles.dayDeviceIcon}>
                                    {d.name === "Mobile" ? "📱" : d.name === "Desktop" ? "💻" : "📲"}
                                </span>
                                <span className={styles.dayDeviceName}>{d.name}</span>
                                <span className={styles.dayDeviceValue}>{d.value}%</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
